import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center mt-5">
            <h1><span className="text-danger">404</span> Page Not Found</h1>
        </div>
    );
};

export default NotFound;